import dateHelper from '@/components/toolkits/dateHelper.vue'

/**
 * Vue 全局过滤器
 */

// 保留两位小数
const toFixed = function (value, fixed) {
  fixed = arguments[1] || 2
  if (!value) return ''
  value = value.toFixed(fixed)
  return value
}

// 时间戳 -> 日期
const stamp2time = function (value) {
  if (!value) return ''
  value = dateHelper.stamp2time(value)
  return value
}

// 时间戳 -> 年月日
const stamp2ymd = function (value) {
  if (!value) return ''
  value = dateHelper.stamp2ymd(value)
  return value
}

export default {
  toFixed, stamp2time, stamp2ymd
}



// WEBPACK FOOTER //
// ./src/components/toolkits/globalFilter.js